import React from 'react';
import { observer } from 'mobx-react';

import { AppRedirect, routeNaming } from '../../../routes';
import { HomeNavbar } from '../../../common/home-navbar';
import { Footer } from '../../../common/footer';
import { ScreenStore } from '../../../stores/ScreenStore';
import { constants } from '../../../config';
import { InformationMenu } from '../information-menu';
import styles from './InformationMenuMobile.css';

const InformationMenuMobile = observer(() => {
  const mobileVersion = ScreenStore.screenWidth <= constants.breakpoints.extraSmallMaxWidth;
  if (!mobileVersion) {
    return (
      <AppRedirect routeName={routeNaming.VENUES_AND_OPEN_HOURS} />
    );
  }
  return (
    <div className={styles.container}>
      <HomeNavbar />
      <div className={styles.mainContent}>
        <InformationMenu />
      </div>
      <Footer />
    </div>);
});

export { InformationMenuMobile };



// WEBPACK FOOTER //
// ./src/pages/information/information-menu-mobile/InformationMenuMobile.jsx